import { jsxs as s, jsx as e, Fragment as j } from "react/jsx-runtime";
import { useState as v, useEffect as N } from "react";
import { ChannelSearch as b } from "../ChannelSearch/ChannelSearch.js";
import { RescanInstructions as W } from "../RescanInstructions/RescanInstructions.js";
import { DeviceAndPlatformLists as M } from "../DeviceAndPlatformLists/DeviceAndPlatformLists.js";
import { GeneralErrorBoundary as c } from "../../error-boundries/GeneralErrorBoundry.js";
import { getViewingPlatforms as x } from "../../utils/getViewingPlatforms.js";
import '../../assets/FindUs.css';const F = "_findus__column_mvuro_8", u = {
  "grid-wrapper": "_grid-wrapper_mvuro_1",
  findus__column: F
};
function G({
  network: t,
  baseApiUrl: d,
  platformsApiUrl: m = "https://api.scrippscloud.com/viewing-platforms/v1",
  authApiUrl: f = "",
  allowStateSearch: h = !0,
  allowZipcodeSearch: p = !0,
  allowAutoScroll: i = !0,
  autoScrollOffset: a = 25,
  compactLayout: n = !0,
  showChannelSearchAndRescan: l = !0,
  numberOfColumns: _,
  ad: y = {
    campaign: "",
    source: "",
    medium: "referral",
    content: "learn_more"
  }
}) {
  const [r, w] = v(null), [g, I] = v(i ? a : 0);
  return N(() => {
    r === null && (async () => {
      const o = await x({ network: t.platformsSlug, platformsApiUrl: m });
      w(o);
    })();
  }, [r, t.platformsSlug, m]), N(() => {
    if (window.innerWidth <= 960) {
      const o = setInterval(() => {
        if (document.querySelector(".mobile-nav")) {
          clearInterval(o);
          const P = document.querySelector(".mobile-nav").offsetHeight;
          I(P + a);
        }
      }, 100);
    }
  }, [a]), /* @__PURE__ */ s("section", { className: [u["find-us"], n ? "find-us--compact" : ""].join(" "), children: [
    l && !n && /* @__PURE__ */ e(
      c,
      {
        errorTitle: "We're sorry, there's currently an issue with our channel search.",
        errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue.",
        children: /* @__PURE__ */ e("div", { className: "find-us__channel-search-section", children: /* @__PURE__ */ e(
          b,
          {
            network: t,
            baseApiUrl: d,
            authApiUrl: f,
            allowZipcodeSearch: p,
            allowStateSearch: h,
            allowAutoScroll: i,
            autoScrollOffset: g,
            compactLayout: n,
            ad: y
          }
        ) })
      }
    ),
    /* @__PURE__ */ e("div", { className: "find-us__rescan-platform-section", children: /* @__PURE__ */ s("div", { className: [u["grid-wrapper"], "findus__grid-wrapper", l ? "" : "findus__grid-wrapper--full-width"].join(" "), children: [
      l && /* @__PURE__ */ s("div", { className: [u.findus__column, "findus__column"].join(" "), children: [
        n && /* @__PURE__ */ s(j, { children: [
          /* @__PURE__ */ s("h4", { className: "channel-search__header", children: [
            "Digital Antenna ",
            /* @__PURE__ */ e("span", { className: "channel-search__header--lighter", children: "(Over-the-Air Broadcast)" })
          ] }),
          /* @__PURE__ */ e(
            c,
            {
              errorTitle: "We're sorry, there's currently an issue with our channel search.",
              errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue.",
              children: /* @__PURE__ */ e(
                b,
                {
                  network: t,
                  baseApiUrl: d,
                  authApiUrl: f,
                  allowZipcodeSearch: p,
                  allowStateSearch: h,
                  allowAutoScroll: i,
                  autoScrollOffset: g,
                  compactLayout: n
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ e(W, { brandName: t.brand_name })
      ] }),
      /* @__PURE__ */ s(
        c,
        {
          errorTitle: "We're sorry, there's currently an issue with our device and platform lists.",
          errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue.",
          children: [
            r !== null && r.size > 0 && r.get("error") === void 0 && /* @__PURE__ */ e(M, { platformResources: r, ..._ && { numberOfColumns: _ } }),
            r !== null && r.size === 0 && /* @__PURE__ */ e("div", { className: "find-us__error", children: /* @__PURE__ */ s("p", { className: "find-us__error-message", children: [
              "We couldn't find any viewing platforms for ",
              t.brand_name,
              "."
            ] }) })
          ]
        }
      )
    ] }) })
  ] });
}
export {
  G as FindUs,
  G as default
};
